import { jwtDecode, JwtPayload } from 'jwt-decode';

const delta = 60000; // time in ms

export const isTokenExpiredOrExpireSoon = (token: string): boolean => {
  const now = Date.now();
  const tokenPayload = jwtDecode<JwtPayload>(token);
  const expirationTime = (tokenPayload?.exp || 0) * 1000;

  return now + delta >= expirationTime;
};
